module.exports = __webpack_public_path__ + "img/down_2.bbf8bef7.jpg";